export const PARKING_HEIGTH = 'height'
export const PARKING_LENGTH = 'length'
